module.exports = __webpack_public_path__ + "static/media/onderhoudsvraag.3e52e2fb.jpg";